import { AxiosError } from 'axios'

import { api } from '~/utils/api'
import { storageAuthKey } from '~/utils/storageKeys'

import { insertToast } from '../toasts/services'
import { authenticationAtom } from './data'
import { AuthenticateAdminDTO, PersonalTrainerSignInDTO } from './schema'
import { Authentication } from './types'

export function signOut() {
  localStorage.clear()
  delete api.defaults.headers.authorization
  authenticationAtom.set(undefined)
}

export function initiateSession() {
  const sessionData = localStorage.getItem(storageAuthKey)

  if (sessionData) {
    const session: Authentication = JSON.parse(sessionData)
    authenticationAtom.set(session)
    api.defaults.headers.authorization = `Bearer ${session.token}`
  }
}

export function updateSessionUser(user: Authentication['user']) {
  const sessionString = localStorage.getItem(storageAuthKey)

  if (sessionString && user) {
    const session: Authentication = JSON.parse(sessionString)
    session.user = user
    localStorage.setItem(storageAuthKey, JSON.stringify(session))
    authenticationAtom.set(session)
  }
}

export async function authenticateAdmin(payload: AuthenticateAdminDTO) {
  await api
    .post<Authentication>('/admin/authenticate', payload)
    .then(({ data }) => {
      if (!data) return
      api.defaults.headers.authorization = `Bearer ${data.token}`
      localStorage.setItem(storageAuthKey, JSON.stringify(data))
      authenticationAtom.set(data)
    })
    .catch((error: AxiosError<APIError>) => {
      if (error.response?.data.message) {
        insertToast({
          title: 'Falha ao autenticar',
          duration: 3,
          message: error.response.data.message,
          type: 'error',
        })
      }
    })
}

export async function authenticatePersonalTrainer(
  payload: PersonalTrainerSignInDTO,
) {
  await api
    .post<Authentication>('personal-trainers/authenticate', payload)
    .then(({ data }) => {
      if (!data) return
      api.defaults.headers.authorization = `Bearer ${data.token}`
      localStorage.setItem(storageAuthKey, JSON.stringify(data))
      authenticationAtom.set(data)
    })
    .catch((error) => {
      console.log(error)
      insertToast({
        title: 'Falha ao autenticar',
        duration: 3,
        message: error.response.data.message,
        type: 'error',
      })
    })
}
